import React from "react";

const Alert = () => {
  return <h1 className="text-center">Data Masih Kosong</h1>;
};

export default Alert;